import { default as indexd1BRu5p1tdMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/taline-shell-game/pages/index.vue?macro=true";
export default [
  {
    name: indexd1BRu5p1tdMeta?.name ?? "index",
    path: indexd1BRu5p1tdMeta?.path ?? "/",
    meta: indexd1BRu5p1tdMeta || {},
    alias: indexd1BRu5p1tdMeta?.alias || [],
    redirect: indexd1BRu5p1tdMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/taline-shell-game/pages/index.vue").then(m => m.default || m)
  }
]